import React from 'react';
import RewardPointsCardView from '../components/rewardPointsCardView';
import { withApollo } from '@apollo/client/react/hoc';
import { compose } from 'modules/core';
import { DASHBOARD_CARD_OVERVIEW } from '../graphql/userDashboardQueries.gql';
import moment from 'moment-timezone';

const RewardPointsCardContainer = (props) => {
  const { client, rewardRecieved, me } = props
  const [rewardData, setRewardData] = React.useState({
    total_points: 0,
    points_earned_this_week: 0,
    recent_activities: []
  });
  const [loading, setLoading] = React.useState(true);

  const getRewardData = async () => {
    try {
      const { data } = await client.query({
        query: DASHBOARD_CARD_OVERVIEW,
        fetchPolicy: 'network-only',
        variables: {
          dateRange: [
            moment().startOf('isoWeek').toISOString(),
            moment().toISOString()
          ]
        }
      });
      if (data) {
        const lastWeekPoints = data.points_for_week.edges.reduce((acc, { node }) => acc + node.points, 0)
        const recentActivities = data.recent_achivement.edges.map(({ node }) => ({ action: node.rule.category.name, points: node.points }))
        setRewardData({
          total_points: data.total_points_earned,
          points_earned_this_week: lastWeekPoints,
          recent_activities: recentActivities
        })
      }
      setLoading(false);
    } catch (error) {
      console.error("Error fetching reward data:", error);
      setLoading(false);
    }
  }

  React.useEffect(() => {
    getRewardData()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [rewardRecieved, props, me])

  return (
    <>
      <RewardPointsCardView rewardData={rewardData} {...props} loading={loading} />
    </>
  )
}
export default compose(withApollo)(RewardPointsCardContainer)